// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoP2App extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.p_2_app";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoP2App {
        this.VALUES ??= this.completar({
            "valor": {
                "en": "Personalized digital advertising, based on information collected through cookies, unique identifiers or or similar technologies in apps, allows us to finance our activity to continue offering you content with high quality standards at no cost.",
                "en-GB": "Personalised digital advertising, based on information collected through cookies, unique identifiers or or similar technologies in apps, allows us to finance our activity to continue offering you content with high quality standards at no cost.",
                "es": "La publicidad digital personalizada, basada en la información recogida mediante cookies, identificadores únicos o tecnologías similares en apps, nos permite financiar nuestra actividad para seguir ofreciéndote contenido con altos estándares de calidad sin coste."
            },
            "defecto": "Personalized digital advertising, based on information collected through cookies, unique identifiers or or similar technologies in apps, allows us to finance our activity to continue offering you content with high quality standards at no cost."
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
